import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const DriversLayout = loadable(
  async () => import("~/features/drivers/pages/DriversLayout"),
  { fallback: <></> },
)
const DriversPage = loadable(
  async () => import("~/features/drivers/pages/DriversView"),
  { fallback: <></> },
)
const DriverDetailsLayout = loadable(
  async () => import("~/features/drivers/pages/DriverDetailsLayout"),
  { fallback: <></> },
)
const DriverDetailsPage = loadable(
  async () => import("~/features/drivers/pages/DriverDetailsView"),
  { fallback: <></> },
)
const DriverBirthdaysPage = loadable(
  async () => import("~/features/driver-birthdays/pages/DriverBirthdaysPage"),
  { fallback: <></> },
)
const DriverDocumentExpiriesPage = loadable(
  async () => import("~/features/driver-document-expiry/pages/DriverDocumentExpiriesPage"),
  { fallback: <></> },
)

export const driverRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.drivers,
    element: <DriversLayout />,
    children: [
      { index: true, element: <DriversPage /> },
      { path: "birthdays", element: <DriverBirthdaysPage /> },
      { path: "document-expiries", element: <DriverDocumentExpiriesPage /> },
    ],
  },
  {
    path: `${APP_ROUTES.drivers}/:driverId`,
    element: <DriverDetailsLayout />,
    children: [{ index: true, element: <DriverDetailsPage /> }],
  },
]
